export default __webpack_public_path__ + "static/media/ShopperrGuides.2ac1f914.pdf";